import React from 'react'

import './styles.css'

const DotLoader = ({height = 16}) => {
    return (
        <div className="loading-dots" style={{height}}>
            <div className="loading-dots--dot"/>
            <div className="loading-dots--dot"/>
            <div className="loading-dots--dot"/>
        </div>
    )
}

export default DotLoader
